import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "./database-code";

export type TimeGroup = DatabaseCode

const hourly: TimeGroup = {
  code: 'HOURLY',
  displayValue: {
    id: 'ots.ui.entity.timegroup.hourly',
    defaultMessage: 'Hourly',
  },
};

const daily: TimeGroup = {
  code: 'DAILY',
  displayValue: {
    id: 'ots.ui.entity.timegroup.daily',
    defaultMessage: 'Daily',
  },
};

const weekly: TimeGroup = {
  code: 'WEEKLY',
  displayValue: {
    id: 'ots.ui.entity.timegroup.weekly',
    defaultMessage: 'Weekly',
  },
};

const semiMonthly: TimeGroup = {
  code: 'SEMI_MONTHLY',
  displayValue: {
    id: 'ots.ui.entity.timegroup.semimonthly',
    defaultMessage: 'Semi-Monthly',
  },
};

const monthly: TimeGroup = {
  code: 'MONTHLY',
  displayValue: {
    id: 'ots.ui.entity.timegroup.monthly',
    defaultMessage: 'Monthly',
  },
};

export const timeGroup = {
  hourly,
  daily,
  weekly,
  semiMonthly,
  monthly,
};

export const timeGroups = Object.values(timeGroup);

export const toTimeGroup = (code: string): TimeGroup => toDatabaseCode(code, timeGroups)

export const toTimeGroupSafely = (code: string | undefined, defaultValue: TimeGroup | undefined = undefined): TimeGroup | undefined => toDatabaseCodeSafely(code, timeGroups, defaultValue)
